/**
 * ChatInnerWithoutHistory Component
 * Layout for chat without history sidebar
 * Matches the structure of ChatInnerWithHistory but for single-chat view
 */

import { faRefresh } from '@fortawesome/pro-regular-svg-icons';
import React from 'react';

import { ChatInner } from '../../../Chat/Chat';
import { useOcFabWidgetOptions } from '../../contexts/OcFabWidgetOptionsContext';
import {
    ocRenderAdditionalActions,
    ocRenderAdditionalMessageUI,
    ocRenderMessage,
} from '../../rendering/ocMessageRendering';
import OcTranscriptFooter from '../AskHuman/OcTranscriptFooter';
import { OcChatFooter } from '../Footer/OcChatFooter';
import OCAILoadingMessage from '../Loading/OCAILoadingMessage';
import ResetChatButton from '../ResetChatButton/ResetChatButton';

export interface ChatInnerWithoutHistoryProps {
    isNarrow?: boolean;
}

/**
 * ChatInnerWithoutHistory
 * Creates a layout with:
 * - Chat content in the main area
 * - Transcript footer (Ask Human box if enabled)
 * - Footer with disclaimer below the chat
 * - Clear Chat button in header
 */
const ChatInnerWithoutHistory: React.FC<ChatInnerWithoutHistoryProps> = ({
    isNarrow = false,
}) => {
    const {
        assistantName,
        avatarUrl,
        inputPlaceholder,
        clearChatButtonText,
        renderMessage,
        renderAdditionalMessageUI,
        renderAdditionalActions,
    } = useOcFabWidgetOptions();

    return (
        <ChatInner
            loadingMessage={<OCAILoadingMessage />}
            transcriptFooter={<OcTranscriptFooter />}
            footer={<OcChatFooter isNarrow={isNarrow} />}
            inputPlaceholder={inputPlaceholder}
            assistantName={assistantName}
            avatarUrl={avatarUrl}
            renderMessage={renderMessage ?? ocRenderMessage}
            renderAdditionalMessageUI={
                renderAdditionalMessageUI ?? ocRenderAdditionalMessageUI
            }
            renderAdditionalActions={
                renderAdditionalActions ?? ocRenderAdditionalActions
            }
            resetButton={
                <ResetChatButton
                    icon={faRefresh}
                    text={clearChatButtonText}
                    className="clear-chat-button"
                />
            }
        />
    );
};

export default ChatInnerWithoutHistory;